<template>
    <v-form @submit.prevent="$emit('submit')" :disabled="disabled">
        <v-row
            class="justify-center align-center pa-8"
            style="background: #f9fafb; border-radius: 16px; box-shadow: 0 2px 12px #0001"
        >
            <v-col cols="12">
                <v-img class="mx-auto" contain width="300" height="160" :src="logoEmpresa"></v-img>
            </v-col>
            <v-col cols="12" class="mb-2">
                <v-alert
                    class="text-left"
                    type="success"
                    v-model="alertExito"
                    dismissible
                    border="left"
                    colored-border
                    elevation="2"
                    style="font-size: 1rem"
                >
                    <p class="my-0" v-text="msjRespuesta"></p>
                </v-alert>
                <v-alert
                    class="text-left"
                    type="error"
                    v-model="alertError"
                    dismissible
                    border="left"
                    colored-border
                    elevation="2"
                    style="font-size: 1rem"
                >
                    <p v-text="msjRespuesta" class="my-0"></p>
                    <ul class="my-0" v-for="(errors, index) in listErrors" :key="index">
                        <li v-text="errors[0]"></li>
                    </ul>
                </v-alert>
            </v-col>
            <v-col cols="12" class="mb-2">
                <v-text-field
                    :value="code"
                    @input="$emit('update:code', $event)"
                    label="Código de 6 dígitos"
                    prepend-icon="mdi-shield-key"
                    maxlength="6"
                    type="text"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    required
                    outlined
                    dense
                    color="primary"
                    hide-details
                />
            </v-col>
            <v-col cols="12" class="mb-4 text-center">
                <p class="mb-0" style="font-size: 0.95rem">
                    ¿No te llegó tu código? Reintenta presionando
                    <a
                        href="#"
                        :class="{ 'text--disabled': disabled }"
                        @click.prevent="$emit('resend')"
                        style="color: #1976d2; text-decoration: underline; cursor: pointer; font-weight: 500"
                    >
                        aquí
                    </a>
                </p>
            </v-col>
            <v-col cols="12" class="text-center">
                <v-btn
                    :loading="disabled"
                    type="submit"
                    color="primary"
                    large
                    elevation="2"
                    style="min-width: 200px; border-radius: 8px"
                >
                    <v-icon left>mdi-check-decagram</v-icon>
                    Verificar código
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
    export default {
        name: 'VerificationForm',
        props: {
            logoEmpresa: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            alertExito: {
                type: Boolean,
                default: false,
            },
            alertError: {
                type: Boolean,
                default: false,
            },
            msjRespuesta: {
                type: String,
                default: '',
            },
            listErrors: {
                type: Array,
                default: () => [],
            },
            code: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style scoped>
    /* Mejoras visuales adicionales */
    .v-alert {
        margin-bottom: 8px;
    }
    .v-text-field input {
        font-size: 1.15rem;
        letter-spacing: 0.1em;
        text-align: center;
    }
    a.text--disabled {
        pointer-events: none;
        opacity: 0.5;
    }
</style>
